import {
  FatcaQuestionsViewQuery,
  FatcaQuestionsViewQuery$data,
  FatcaQuestionsViewQueryNode,
} from '@bts-web/data-layer/server';
import { gqlNetworkFetch } from '@bts-web/utils-relay';

export type FatcaQuestionsResult = {
  data: FatcaQuestionsViewQuery$data;
  errors?: string[];
};

export const getFatcaQuestions = async () => {
  const response = await gqlNetworkFetch<FatcaQuestionsViewQuery>(
    FatcaQuestionsViewQueryNode.params,
    {},
  );

  return response;
};
